import { call, put, takeLatest } from 'redux-saga/effects'

import { postCulture, putCulture, deleteCulture } from '@galo-monitor/services/apis/galoMonitorApi/resources/culture'

import { CultureActions, CultureTypes } from './duckCulture'

function* saveCulture({ culture, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(culture.id ? putCulture : postCulture , culture)
    yield call(onSuccess)
  } catch (err) {
    yield put(CultureActions.cultureError(err.message))
    yield call(onError, err)
  }
}

function* removeCulture({ culture, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteCulture, culture)
    yield call(onSuccess)
  } catch (err) {
    yield put(CultureActions.cultureError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(CultureTypes.SAVE_CULTURE, saveCulture),
  takeLatest(CultureTypes.REMOVE_CULTURE, removeCulture)
]
